import * as React from 'react';
import { createViewConfig, view } from '@sail/engine';
import { styles, variants, globalBodyStyles } from './CopyStyles';
import { Title } from './Title';
import { CopyHeaderLayout } from './CopyHeaderLayout';
import { CopyBodyLayout } from './CopyBodyLayout';
import { CopyFooterLayout } from './CopyFooterLayout';
export const CopyConfig = createViewConfig({
    props: {},
    name: 'Copy',
    defaults: {
        variant: 'section'
    }
});
/**
 * Layout component used to handle copy layouts
 */ export const Copy = CopyConfig.createView(({ body, caption, children, cta, icon, subviews, title, variant, ...rest })=>{
    return /*#__PURE__*/ React.createElement(view.section, rest, (icon || caption || title) && /*#__PURE__*/ React.createElement(CopyHeaderLayout, {
        inherits: subviews.header
    }, icon && /*#__PURE__*/ React.createElement(view.div, {
        inherits: subviews.icon
    }, icon), caption && /*#__PURE__*/ React.createElement(view.h2, {
        inherits: subviews.caption
    }, caption), title && /*#__PURE__*/ React.createElement(Title, {
        inherits: subviews.title,
        variant: variant
    }, title)), body && /*#__PURE__*/ React.createElement(CopyBodyLayout, {
        inherits: subviews.body
    }, body), (children || cta) && /*#__PURE__*/ React.createElement(CopyFooterLayout, {
        inherits: subviews.footer
    }, cta && /*#__PURE__*/ React.createElement(view.div, {
        uses: [
            styles.copyCtaContainer
        ]
    }, cta), children));
}, {
    variants,
    forward: {
        variant: true
    },
    uses: [
        styles.copy,
        globalBodyStyles
    ],
    subviews: {
        icon: {
            uses: [
                styles.copyIcon
            ]
        },
        caption: {
            uses: [
                styles.copyCaption
            ]
        }
    }
});

//# sourceMappingURL=Copy.js.map